import * as React from 'react';

import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { PropertyListingBadgeModel } from 'models';

import { UitkLayoutPosition } from 'uitk-react-layout-position';

import { BadgeGenerator } from 'components/common/badge-generation';

interface RenderBadgeProps {
  propertyListingBadgeModel?: PropertyListingBadgeModel;
}

export const TertiaryBadge: React.FunctionComponent<RenderBadgeProps> = ({ propertyListingBadgeModel }) => {
  const { tertiary } = { ...propertyListingBadgeModel };
  const tertiaryIsSafe = tertiary && (tertiary.text || tertiary.icon || tertiary.mark);

  return (
    <>
      {tertiaryIsSafe && (
        <Viewport>
          <ViewSmall>
            <UitkLayoutPosition type="absolute" position={{ bottom: 'three', left: 'two', zindex: 'layer3' }}>
              <BadgeGenerator badge={tertiary || {}} />
            </UitkLayoutPosition>
          </ViewSmall>
          <ViewMedium>
            <UitkLayoutPosition type="absolute" position={{ bottom: 'three', left: 'three', zindex: 'layer3' }}>
              <BadgeGenerator badge={tertiary || {}} />
            </UitkLayoutPosition>
          </ViewMedium>
        </Viewport>
      )}
    </>
  );
};

TertiaryBadge.displayName = 'TertiaryBadge';
